/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetOrdersQueryResponse, GetOrdersQueryParams, GetOrders400 } from '../entities/GetOrders'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getOrders } from '../api/getOrders'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getOrdersQueryKey = (params: GetOrdersQueryParams) => [{ url: '/orders' }, ...(params ? [params] : [])] as const

export type GetOrdersQueryKey = ReturnType<typeof getOrdersQueryKey>

export function getOrdersQueryOptions(params: GetOrdersQueryParams, config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const queryKey = getOrdersQueryKey(params)
  return queryOptions<GetOrdersQueryResponse, ResponseErrorConfig<GetOrders400>, GetOrdersQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getOrders(params, config)
    },
  })
}

/**
 * @description Get orders
 * @summary Get orders
 * {@link /orders}
 */
export function useGetOrders<TData = GetOrdersQueryResponse, TQueryData = GetOrdersQueryResponse, TQueryKey extends QueryKey = GetOrdersQueryKey>(
  params: GetOrdersQueryParams,
  options: {
    query?: Partial<QueryObserverOptions<GetOrdersQueryResponse, ResponseErrorConfig<GetOrders400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof client }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? getOrdersQueryKey(params)

  const query = useQuery(
    {
      ...(getOrdersQueryOptions(params, config) as unknown as QueryObserverOptions),
      queryKey,
      ...(queryOptions as unknown as Omit<QueryObserverOptions, 'queryKey'>),
    },
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetOrders400>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}